import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { useAppSelector, useAppDispatch } from '../hooks';
import { clusterNameAndHex } from '../types/Zigbee/Cluster';
import { attributeNameOrHex } from '../types/Zigbee/Attribute';
import { fetchZigbeeNodeCluster } from '../actions/FetchZigbeeNodeCluster';
import { showDialog } from '../reducers/app';
import { ZigbeeAttributeValue } from '../features/zigbee/ZigbeeAttributeValue';
import { CommandsOnOff } from './config/zigbee/commands/OnOff';
import { CommandsLevel } from './config/zigbee/commands/Level';
import { CommandsGroups } from './config/zigbee/commands/Groups';
import { CommandsOTA } from './config/zigbee/commands/OTA';
import { CommandsDoorLock } from './config/zigbee/commands/DoorLock';
import { DialogEditAttribute } from './DialogEditAttribute';
function reportingTitle(reporting) {
    var _a;
    if ((reporting === null || reporting === void 0 ? void 0 : reporting.type) === 'reported') {
        let t = 'Reported';
        t += ' min=' + reporting.min_seconds;
        t += ' max=' + reporting.max_seconds;
        t += reporting.change === undefined ? '' : (' change=' + ((_a = reporting.change.value) === null || _a === void 0 ? void 0 : _a.toString()));
        return t;
    }
    else if ((reporting === null || reporting === void 0 ? void 0 : reporting.type) === 'received') {
        let t = 'Received';
        t += ' timeout' + reporting.timeout;
        return t;
    }
    else {
        return '';
    }
}
const Cluster = (props) => {
    var _a, _b, _c;
    const zigbee_device_info = useAppSelector(state => state.zigbee_device_info);
    const deviceInfo = zigbee_device_info[props.nid];
    const rows = [];
    for (const a of Object.values(props.attributes)) {
        const name = attributeNameOrHex(props.cluster, a.attribute_id);
        const reporting = (_c = (_b = (_a = deviceInfo === null || deviceInfo === void 0 ? void 0 : deviceInfo.reporting) === null || _a === void 0 ? void 0 : _a[props.eid]) === null || _b === void 0 ? void 0 : _b[props.cluster]) === null || _c === void 0 ? void 0 : _c[a.attribute_id];
        const reportedText = (reporting === null || reporting === void 0 ? void 0 : reporting.type) !== undefined ? (_jsx("span", { title: reportingTitle(reporting), children: " \uD83D\uDEDC" })) : '';
        const onOpenDialog = (attribute_id) => {
            const attribute_value = props.attributes[attribute_id];
            if (attribute_value != undefined) {
                props.onOpenDialog(props.cluster, props.dir, attribute_value);
            }
        };
        rows.push(_jsxs("tr", { onClick: () => onOpenDialog(a.attribute_id), children: [_jsxs("td", { children: [name, reportedText] }), _jsx("td", { children: a.typedValue.type }), _jsx("td", { children: _jsx(ZigbeeAttributeValue, { nid: props.nid, eid: props.eid, cid: props.cluster, aid: a.attribute_id }) })] }, a.attribute_id));
    }
    let cmd;
    switch (props.cluster) {
        case 0x0004:
            cmd = (_jsx(CommandsGroups, { nid: props.nid, eid: props.eid }));
            break;
        case 0x0006:
            cmd = (_jsx(CommandsOnOff, { nid: props.nid, eid: props.eid }));
            break;
        case 0x0008:
            cmd = (_jsx(CommandsLevel, { nid: props.nid, eid: props.eid }));
            break;
        case 0x0019:
            cmd = (_jsx(CommandsOTA, { nid: props.nid, eid: props.eid }));
            break;
        case 0x0101:
            cmd = (_jsx(CommandsDoorLock, { nid: props.nid, eid: props.eid }));
            break;
        default:
            cmd = null;
    }
    return (_jsxs("div", { children: [_jsxs("h3", { children: ["Cluster ", clusterNameAndHex(props.cluster), "\u00A0\u00A0", _jsx("button", { type: "button", onClick: () => props.onFetchCluster(props.cluster, props.dir), children: "\uD83D\uDDD8" })] }), _jsx("table", { children: _jsx("tbody", { children: rows }) }), cmd] }, props.cluster));
};
export const ConfigZigbeeEndpointAttributes = (props) => {
    var _a, _b, _c, _d;
    const dispatch = useAppDispatch();
    const [dialogClusterID, setDialogClusterID] = useState();
    const [dialogDirection, setDialogDirection] = useState('server');
    const [dialogAttribute, setDialogAttribute] = useState();
    const zigbee_device_info = useAppSelector(state => state.zigbee_device_info);
    const deviceInfo = zigbee_device_info[props.node];
    const attributes = deviceInfo === null || deviceInfo === void 0 ? void 0 : deviceInfo.attributes[props.endpoint];
    const endpoint = deviceInfo === null || deviceInfo === void 0 ? void 0 : deviceInfo.endpoints[props.endpoint];
    const dialogId = 'dialog-edit-attribute-' + props.endpoint;
    const openDialog = (cluster_id, dir, attribute) => {
        setDialogClusterID(cluster_id);
        setDialogDirection(dir);
        setDialogAttribute(attribute);
        dispatch(showDialog(dialogId));
    };
    const in_items = [];
    const sorted_in_clusters = [...((_a = endpoint === null || endpoint === void 0 ? void 0 : endpoint.input_clusters) !== null && _a !== void 0 ? _a : [])].sort();
    for (const c of sorted_in_clusters) {
        const attr = (_b = attributes === null || attributes === void 0 ? void 0 : attributes[c]) !== null && _b !== void 0 ? _b : {};
        in_items.push(_jsx(Cluster, { nid: props.node, eid: props.endpoint, cluster: c, dir: 'server', attributes: attr, onFetchCluster: () => dispatch(fetchZigbeeNodeCluster(props.node, props.endpoint, c, 'server')), onOpenDialog: openDialog }, c + '-in'));
    }
    const out_items = [];
    const sorted_out_clusters = [...((_c = endpoint === null || endpoint === void 0 ? void 0 : endpoint.output_clusters) !== null && _c !== void 0 ? _c : [])].sort();
    for (const c of sorted_out_clusters) {
        const attr = (_d = attributes === null || attributes === void 0 ? void 0 : attributes[c]) !== null && _d !== void 0 ? _d : {};
        out_items.push(_jsx(Cluster, { nid: props.node, eid: props.endpoint, cluster: c, dir: 'client', attributes: attr, onFetchCluster: () => dispatch(fetchZigbeeNodeCluster(props.node, props.endpoint, c, 'client')), onOpenDialog: openDialog }, c + '-out'));
    }
    const dialog = dialogClusterID != undefined && dialogAttribute != undefined ?
        _jsx(DialogEditAttribute, { id: dialogId, nid: props.node, eid: props.endpoint, cid: dialogClusterID, dir: dialogDirection, attribute: dialogAttribute }, props.endpoint)
        : null;
    return (_jsxs("div", { children: [dialog, _jsx("h2", { children: "Server clusters" }), in_items, _jsx("h2", { children: "Client clusters" }), out_items] }));
};
